/**
 * PDP accordions — opens the first accordion in the product info column
 * (Product description) on load, so the PDP reads like a stacked accordion
 * list with the description already expanded.
 *
 * Open/close behaviour itself comes from the theme's <toggle-tab> element
 * (assets/component-toggle.js); this only triggers its own click handler.
 */

(function () {
  if (window.__pdpAccordionInit) return;
  window.__pdpAccordionInit = true;

  function openFirst(root) {
    const scope = root && root.querySelector ? root : document;
    const first = scope.querySelector('.product-text toggle-tab');
    if (!first || first.classList.contains('opened')) return;
    if (typeof first.onClickHandler === 'function') first.onClickHandler();
  }

  function init(root) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('toggle-tab').then(() => openFirst(root));
    } else {
      openFirst(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/**
 * "As seen on you" creator clips (snippets/pdp-ugc.liquid): play on hover
 * (desktop) or tap (touch), muted and inline, one clip at a time. Clips
 * use preload="none" so nothing downloads until a shopper interacts.
 */
(function () {
  if (window.__pdpUgcInit) return;
  window.__pdpUgcInit = true;

  function pauseOthers(current) {
    document.querySelectorAll('[data-pdp-ugc-video]').forEach((v) => {
      if (v !== current && !v.paused) v.pause();
    });
  }

  function play(video) {
    pauseOthers(video);
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }

  function bind(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-pdp-ugc-video]').forEach((video) => {
      if (video.__ugcBound) return;
      video.__ugcBound = true;
      if (window.matchMedia('(hover: hover)').matches) {
        video.addEventListener('mouseenter', () => play(video));
        video.addEventListener('mouseleave', () => video.pause());
      }
      video.addEventListener('click', () => (video.paused ? play(video) : video.pause()));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind());
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', (e) => bind(e.target));
})();
